import React from 'react'
import { makeStyles } from 'tss-react/mui'
import ComplianceModal from '../Modals/ComplianceModal'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useComplianceNote } from '../../hooks/useComplianceNote'
import { WidgetTRefs } from '../../types/widget'
import { Typography, TypographyProps } from '@mui/material'

export default function ComplianceNote({
  children,
}: {
  children?: React.ReactNode
}): JSX.Element {
  const { t } = useTranslation()
  const {
    complianceLinkText,
    handleComplianceModalClose,
    complianceModalData,
  } = useComplianceNote()

  return (
    <>
      {children}
      <ComplianceModal
        open={complianceLinkText === t(`${WidgetTRefs.CommonTRef}.pp`)}
        onClose={handleComplianceModalClose}
        rawBody={complianceModalData.pp.body.raw}
        references={complianceModalData.pp.body.references}
      />
      <ComplianceModal
        open={complianceLinkText === t(`${WidgetTRefs.CommonTRef}.tos`)}
        onClose={handleComplianceModalClose}
        rawBody={complianceModalData.tos.body.raw}
        references={complianceModalData.tos.body.references}
      />
    </>
  )
}

ComplianceNote.TextPrivacy = function TextPrivacy({
  className,
  ...rest
}: TypographyProps) {
  const { classes, cx } = useStyles()

  return (
    <Typography
      component="span"
      variant="caption"
      className={cx(classes.privacyText, className)}
      {...rest}
    />
  )
}

ComplianceNote.TextLink = function TextLink({
  className,
  ...rest
}: TypographyProps) {
  const { classes, cx } = useStyles()

  return (
    <Typography
      component="span"
      variant="caption"
      className={cx(classes.linkText, className)}
      {...rest}
    />
  )
}

const useStyles = makeStyles()((theme) => ({
  privacyText: {
    textAlign: 'center',
    marginTop: '1rem',
    '&&': {
      color: theme.palette.text.primary,
    },
  },
  linkText: {
    cursor: 'pointer',
    color: '#0DA1EC',
    fontWeight: 600,
    textDecoration: 'underline',
  },
}))
